import { createContext } from 'react';
import { Storyblok } from '../../storyblok';

interface Context {
    calculator_components: any;
    calculator_enabled: boolean;
    contactFormButtonLabel: string;
    contactFormFields: Storyblok.Component.InputField[];
    contact_form_enabled: boolean;
    contact_form_submitted_message: string;
    content: string;
    logo: string;
    logoPadding: boolean;
    trustboxCode: string;
    slug: string;
}

export const OfferContext = createContext<Context>(undefined!);
